<template>
  <div>
    <v-row>
      <v-col class="d-flex" cols="12" sm="12">
        <v-card elevation="5" class="pa-2 text-center">
          <p class="px-10 py-5">
            Due to a global postal regulation effective 1 January 2021, 
            customers sending an item of value to foreign countries will be 
            required to provide certain details in advance. These details will 
            be sent electronically to the postal operator in the destination 
            country and for cross-border e-commerce postal traffic, and will also 
            be utilised for customs clearance processes.
          </p>
          <p class="px-10 py-5">
            For items destined to non-EU countries, this declaration also includes 
            the printed customs declaration form (CN22/CN23) to be attached to the 
            outside of the package.
          </p>

          <p class="px-10 py-5">
            Items with value greater than €1,000 exported to non-EU countries require a Customs Export Declaration.

            All returns for repair, irrespective of value, to non-EU countries should also have an Customs Export declaration. 
            
            This will avoid the sender to re-pay the VAT and duties, when the same repaired item is returned back to Malta.
          </p>

          <p>E-sellers frequently using this portal should consider using the e-sellers platform <a target="_blank" href="https://www.maltapost.com/eseller">here</a>.</p>
          <v-btn
            color="primary"
            @click="startAnotherDeclaration()"
            class="px-10 py-5 mb-5"
          >
            Start Declaration
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Intro",
  data: () => ({}),
  computed: {},
  methods: {
    startAnotherDeclaration: function () {
      this.$store.dispatch("declarations/startAnotherDeclaration");
    },
  },
};
</script>
